export function matchesSearchQuery(initialText, initialQuery) {
  const text = (initialText || '').trim().toLowerCase();
  const query = (initialQuery || '').trim().toLowerCase();
  return text.includes(query);
}

export function capitalizeMessage(str, addFullstop = true) {
  try {
    let sentance = str.trim();
    sentance = sentance.charAt(0).toUpperCase() + sentance.slice(1);
    return '.,?'.includes(sentance[sentance.length - 1]) && addFullstop ? sentance : `${sentance}.`;
  } catch {
    return str;
  }
}
